/** Dev default: Vite proxy `/api` — same-origin for httpOnly refresh cookie. Override with VITE_API_URL. */
export const API_BASE =
  import.meta.env.VITE_API_URL ??
  (import.meta.env.DEV ? '/api' : '/api');
